import { hasValue, isValueFalsey } from '../../internal';
export const isValidNumber = value => {
  const regex = /^([-]?)(\d*\.?\d*|\d{1,3}(,\d{3})*(\.\d+)?)$/;
  return regex.test(value);
};
export const isPhoneNumberValid = value => {
  const regex = /\(?([2-9]{1}\d{2})\)?([\s.-]{1}?)?([2-9]{1}\d{2})([\s.-]{1}?)?(\d{4})/;
  return value ? regex.test(value) : false;
};
export const isValidUSPostalCode = value => {
  const regex = /^[0-9]{1}\d{4}$/;
  return value ? regex.test(value) : false;
};
export const isValidUSPlus4PostalCode = value => {
  const regex = /^[0-9]{1}\d{4}([ ]?)\d{4}$/;
  return value ? regex.test(value) : false;
};
export const isValidCAPostalCode = value => {
  const regex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
  return value ? regex.test(value) : false;
};
export const validateLength = (value, lengthLimit, direction) => {
  if (!value || !hasValue(value)) return false;
  if (isValueFalsey(lengthLimit)) return false;
  if (!lengthLimit) return false;
  switch (direction) {
    case 'lessThan':
      return value.length < lengthLimit;
    case 'greaterThan':
      return value.length > lengthLimit;
    case 'equalTo':
      return value.length === lengthLimit;
    default:
      return false;
  }
};
export const isPriceValid = value => {
  const priceRegex = /^[-]?[$]?\d+(,\d{3})*((.)\d{0,2})?$/;
  return priceRegex.test(value);
};
export const isEmailValid = emailAddress => {
  // Source: http://emailregex.com/
  const regEx = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regEx.test(emailAddress.trim());
};

/**
 * Validates that a number does not exceed the maximum value
 * @param   {float|number|string}  value     The value to check
 * @param   {float|number|string}  maxValue  The maximum value
 * @returns {boolean} Returns false if the value is less than or equal to the maximum value
 * @throws {error} if the value parameter or the maxValue parameters are not a finite number
 */
export const valueExceedsMaxValue = (value, maxValue) => {
  if (!value || !maxValue || !hasValue(value) || !hasValue(maxValue)) {
    return false;
  }
  const parsedValue = typeof value === 'string' ? parseFloat(value) : value;
  const parsedMaxValue = typeof maxValue === 'string' ? parseFloat(maxValue) : maxValue;
  if (!Number.isFinite(parsedValue) || !Number.isFinite(parsedMaxValue)) {
    return false;
  }
  return parsedValue > parsedMaxValue;
};

/**
 * Validates that a number is greater than the minimum value
 * @param {number|float|string}  value     The value to check
 * @param {number|float|string}  minValue  The minimum value
 * @returns {boolean} returns false if the value is greater than or equal to the minimum value
 * @throws {error} if the value parameter or the minValueRule parameters are not a finite number
 */
export const valueLessThanMinValue = (value, minValue) => {
  if (isValueFalsey(value) || isValueFalsey(minValue) || !hasValue(value) || !hasValue(minValue)) {
    return false;
  }
  const parsedValue = typeof value === 'string' ? parseFloat(value) : value;
  const parsedMinValue = typeof minValue === 'string' ? parseFloat(minValue) : minValue;
  if (parsedValue === undefined || parsedMinValue === undefined || !Number.isFinite(parsedValue) || !Number.isFinite(parsedMinValue)) {
    return false;
  }
  return parsedValue < parsedMinValue;
};